export enum CardTypes {
  _UPDATE_MY_CARDS = '_UPDATE_MY_CARDS',
  GET_MY_CARDS_CALL = 'GET_MY_CARDS_CALL',
  DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST',
  DELETE_CARD_REQUEST_SUCCESS = 'DELETE_CARD_REQUEST_SUCCESS',
  DELETE_CARD_REQUEST_ERROR = 'DELETE_CARD_REQUEST_ERROR',

  ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS',
}

export interface CardState {
  myCards: Card[]
}

export interface Card {
  id: string
  card_type: string
  card_logo: string
  card_prefix: string
  card_suffix: string
  expiry_month: string
  expiry_year: string
}
